import authFetch from './fetch';
import { makeRequest, getQueryParams } from './utils';
import { useQuery } from '@tanstack/react-query';
import { CacheConfig } from './consts';

const OWNERS_PATH = '/api/Owners';

export const getOwners = (params) => makeRequest(authFetch.get(`${OWNERS_PATH}${getQueryParams(params)}`));

export const getOwnersDetailedLookup = (params) => makeRequest(
  authFetch.get(`${OWNERS_PATH}/detailed-lookup${getQueryParams(params)}`),
);

export const getGWIOwnersDetails = () => makeRequest(
  authFetch
    .get(`${OWNERS_PATH}/detailed-lookup${getQueryParams({ search: 'gulf winds' })}`)
    .then(({ data }) => ({ data: data?.[0] ?? null })),
);
export const useGetGWIOwnersDetails = (opts = {}) => useQuery(['GWIOwnersDetails'], getGWIOwnersDetails, { ...CacheConfig.forever, ...opts });

export const getOwnerById = (id) => makeRequest(authFetch.get(`${OWNERS_PATH}/${id}`));

export const postOwner = (owner) => makeRequest(authFetch.put(OWNERS_PATH, owner));

export const deleteOwner = (id) => makeRequest(authFetch.delete(`${OWNERS_PATH}/${id}`));

export const restoreOwner = (id) => makeRequest(authFetch.patch(`${OWNERS_PATH}/${id}/restore`));

export const getOwnerFileTypes = async () => makeRequest(authFetch.get(`${OWNERS_PATH}/Files/Types`));

export const getOwnerFiles = (id, params) => makeRequest(
  authFetch.get(`${OWNERS_PATH}/${id}/Files${getQueryParams(params)}`),
);

export const postOwnerFiles = (id, files) => makeRequest(
  authFetch.post(`${OWNERS_PATH}/${id}/Files`, files),
);

export const deleteOwnerFile = (ownerId, fileId) => makeRequest(
  authFetch.delete(`${OWNERS_PATH}/${ownerId}/Files/${fileId}`),
);

export const putOwnerFile = (ownerId, fileId, file) => makeRequest(
  authFetch.put(`${OWNERS_PATH}/${ownerId}/Files/${fileId}`, file),
);

export const getOwnerTaxIdStatus = (taxId, isSsn) => makeRequest(
  authFetch.get(`${OWNERS_PATH}/validateTaxId${getQueryParams({ taxId, isSsn })}`),
);

export const getOwnerAudits = (id, params) => makeRequest(
  authFetch.get(`${OWNERS_PATH}/${id}/Audits${getQueryParams(params)}`),
);

export const getOwnerAuditProperties = (id) => makeRequest(
  authFetch.get(`${OWNERS_PATH}/${id}/Audits/Properties`),
);

export const getOwnerAuditUsers = (id) => makeRequest(authFetch.get(`${OWNERS_PATH}/${id}/Audits/Users`));

export const getDriverDetailsById = (driverId) => makeRequest(
  authFetch.get(`${OWNERS_PATH}/driverDetails/${driverId}`),
);

// Notes
export const getOwnerNotes = (ownerId, params) => makeRequest(
  authFetch.get(`${OWNERS_PATH}/${ownerId}/notes${getQueryParams(params)}`),
);

export const saveOwnerNote = (ownerId, note) => makeRequest(
  authFetch.post(`${OWNERS_PATH}/${ownerId}/notes`, note),
);

export const pinOwnerNote = (ownerId, noteId, pinState) => makeRequest(
  authFetch.patch(`${OWNERS_PATH}/${ownerId}/notes/${noteId}/pin`, pinState),
);
